import { useEffect, useRef, useState } from 'react';

import NProgress from 'nprogress';
import { useLocation } from 'react-router-dom';

NProgress.configure({
  showSpinner: false,
  minimum: 0.1,
  speed: 200,
  trickleSpeed: 200,
});

export function ProgressBar() {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    if (!isFirstLoad) {
      return undefined;
    }

    NProgress.start();
    const timer = setTimeout(() => {
      NProgress.done();
      setIsFirstLoad(false);
    }, 500);

    return () => {
      clearTimeout(timer);
      NProgress.done();
    };
  }, [isFirstLoad]);

  useEffect(() => {
    if (prevPathRef.current === null) {
      prevPathRef.current = location.pathname;
      return undefined;
    }

    if (prevPathRef.current !== location.pathname) {
      NProgress.start();

      const timer = setTimeout(() => {
        NProgress.done();
      }, 100);

      prevPathRef.current = location.pathname;

      return () => {
        clearTimeout(timer);
        NProgress.done();
      };
    }

    return undefined;
  }, [location.pathname]);

  return null;
}
